// extracted by mini-css-extract-plugin
module.exports = {"Leaderboard":"Leaderboard_Leaderboard__226DR","board":"Leaderboard_board__2idzq","content":"Leaderboard_content__1FH4f","ScoreList":"Leaderboard_ScoreList__3xPv9"};